import {
  FETCH_COMPANIES_REQUEST,
  FETCH_COMPANIES_SUCCEEDED,
  FETCH_COMPANIES_FAILED
} from '../actions/companyActions'

const initialState = {
  ids: [],
  page: 1,
  totalPages: 0,
  isLoading: false,
  query: ''
}

const companies = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPANIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      }
    case FETCH_COMPANIES_SUCCEEDED:
      const { response } = action

      return {
        ...state,
        isLoading: false,
        totalPages: response.meta.totalPages,
        ids: response.result
      }
    case FETCH_COMPANIES_FAILED:
      return { ...state, isLoading: false }
    default:
      return state
  }
}

export default companies



// WEBPACK FOOTER //
// ../src/reducers/companies.js